// extracted by mini-css-extract-plugin
export default {"emptyState":"EmptyRecord_emptyState__R7oaT","icon":"EmptyRecord_icon__KhOs8"};